__turbopack_context__.v({
  "burgerMenu": "Header-module-scss-module__7sz-Mq__burgerMenu",
  "burgerMenuBtn": "Header-module-scss-module__7sz-Mq__burgerMenuBtn",
  "burgerMenuCaretClose": "Header-module-scss-module__7sz-Mq__burgerMenuCaretClose",
  "burgerMenuCaretOpen": "Header-module-scss-module__7sz-Mq__burgerMenuCaretOpen",
  "burgerMenuClose": "Header-module-scss-module__7sz-Mq__burgerMenuClose",
  "burgerMenuHeader": "Header-module-scss-module__7sz-Mq__burgerMenuHeader",
  "burgerMenuOpen": "Header-module-scss-module__7sz-Mq__burgerMenuOpen",
  "burgerMenuSubheader": "Header-module-scss-module__7sz-Mq__burgerMenuSubheader",
  "capacitorHeaderRow": "Header-module-scss-module__7sz-Mq__capacitorHeaderRow",
  "capacitorMainContainer": "Header-module-scss-module__7sz-Mq__capacitorMainContainer",
  "capacitorPlaceholder": "Header-module-scss-module__7sz-Mq__capacitorPlaceholder",
  "connectBtn": "Header-module-scss-module__7sz-Mq__connectBtn",
  "consolidationBtnActive": "Header-module-scss-module__7sz-Mq__consolidationBtnActive",
  "consolidationDropDown": "Header-module-scss-module__7sz-Mq__consolidationDropDown",
  "consolidationDropdownBtn": "Header-module-scss-module__7sz-Mq__consolidationDropdownBtn",
  "dMdBlock": "Header-module-scss-module__7sz-Mq__dMdBlock",
  "dMdNone": "Header-module-scss-module__7sz-Mq__dMdNone",
  "dropdownItemHeader": "Header-module-scss-module__7sz-Mq__dropdownItemHeader",
  "dropdownItemProfile": "Header-module-scss-module__7sz-Mq__dropdownItemProfile",
  "fontBlack": "Header-module-scss-module__7sz-Mq__fontBlack",
  "headerPlaceholder": "Header-module-scss-module__7sz-Mq__headerPlaceholder",
  "headerPlaceholderCapacitor": "Header-module-scss-module__7sz-Mq__headerPlaceholderCapacitor",
  "headerRight": "Header-module-scss-module__7sz-Mq__headerRight",
  "headerRow": "Header-module-scss-module__7sz-Mq__headerRow",
  "headerRowSmall": "Header-module-scss-module__7sz-Mq__headerRowSmall",
  "logoIcon": "Header-module-scss-module__7sz-Mq__logoIcon",
  "logoIconSmall": "Header-module-scss-module__7sz-Mq__logoIconSmall",
  "mainContainer": "Header-module-scss-module__7sz-Mq__mainContainer",
  "mainContainerSmall": "Header-module-scss-module__7sz-Mq__mainContainerSmall",
  "mainNavLink": "Header-module-scss-module__7sz-Mq__mainNavLink",
  "mainNavLinkPadding": "Header-module-scss-module__7sz-Mq__mainNavLinkPadding",
  "nestedMenu": "Header-module-scss-module__7sz-Mq__nestedMenu",
  "new": "Header-module-scss-module__7sz-Mq__new",
  "rowContainer": "Header-module-scss-module__7sz-Mq__rowContainer",
  "submenuContainer": "Header-module-scss-module__7sz-Mq__submenuContainer",
  "userBtn": "Header-module-scss-module__7sz-Mq__userBtn",
  "userBtnIcon": "Header-module-scss-module__7sz-Mq__userBtnIcon",
  "userDropdown": "Header-module-scss-module__7sz-Mq__userDropdown",
  "userProfileBtn": "Header-module-scss-module__7sz-Mq__userProfileBtn",
  "viewModeDropdown": "Header-module-scss-module__7sz-Mq__viewModeDropdown",
  "viewModeIcon": "Header-module-scss-module__7sz-Mq__viewModeIcon",
  "viewModeIconConsolidation": "Header-module-scss-module__7sz-Mq__viewModeIconConsolidation",
});
